import styled from "styled-components";

export const ContainerModalImage = styled.div`
  width: 100%;
  height: 548px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  @media (max-height: 600px){
    height: 90%;
    padding: 10px;
  }
  button {
    width: 127px;
    min-height: 46px;
    border: none;
    background: none;
    border-radius: 8px;
    color: var(--color-white);
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
  }
  .container-btn {
    display: flex;
    gap: 30px;
  }
  .danger {
    background: var(--color-danger);
  }
  .success {
    background: var(--color-broccoli);
  }
  img {
    width: 90%;
    height: 200px;
    object-fit: cover;
  }
  span {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    width: 80%;
  }
`;
